import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useSummaryByDisplayMode, useSummaryChunkSize } from '../selectors';
import { TotalSummaryRow } from './totalSummaryRow';
export var ExpandableTotalSection = function (_a) {
  var label = _a.label,
    valueKey = _a.valueKey,
    expansionKey = _a.expansionKey,
    expandedItems = _a.expandedItems,
    onToggleItem = _a.onToggleItem,
    _b = _a.showVariance,
    showVariance = _b === void 0 ? true : _b,
    decimal = _a.decimal,
    _c = _a.hasChildren,
    hasChildren = _c === void 0 ? true : _c,
    children = _a.children;
  var data = useSummaryByDisplayMode();
  var chunkSize = useSummaryChunkSize();
  if (!data) return null;
  var expanded = expandedItems === null || expandedItems === void 0 ? void 0 : expandedItems[expansionKey];
  return _jsxs(_Fragment, {
    children: [_jsx(TotalSummaryRow, {
      label: label,
      valueKey: valueKey,
      data: data,
      chunkSize: chunkSize,
      showVariance: showVariance,
      expanded: expanded,
      onToggle: hasChildren ? function () {
        return onToggleItem === null || onToggleItem === void 0 ? void 0 : onToggleItem(expansionKey);
      } : undefined,
      decimal: decimal
    }), expanded && children]
  });
};